// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u8().primaryKey(),
  tick: __t.u64(),
  dayPhase: __t.f64().name("day_phase"),
  daySeconds: __t.i32().name("day_seconds"),
  nextEntity: __t.u16().name("next_entity"),
  playerListDirty: __t.bool().name("player_list_dirty"),
  lastPlayerList: __t.u64().name("last_player_list"),
  lastAt: __t.timestamp().name("last_at"),
  nextInstance: __t.u32().name("next_instance"),
  maxIntervalUs: __t.i64().name("max_interval_us"),
});
